;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/app/conto-economico/:id\",\"regex\":\"^/app/conto-economico/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/app/conto-economico/admin/create/:userId\",\"regex\":\"^/app/conto-economico/admin/create/([^/]+)$\",\"paramNames\":[\"userId\"]},{\"path\":\"/app/users/:id\",\"regex\":\"^/app/users/([^/]+)$\",\"paramNames\":[\"id\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/app\"},{\"path\":\"/app/conto-economico\"},{\"path\":\"/app/dashboard\"},{\"path\":\"/app/settings\"},{\"path\":\"/app/users\"},{\"path\":\"/cookie-policy\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/reset-password\"},{\"path\":\"/sign-up\"},{\"path\":\"/termini-condizioni\"},{\"path\":\"/verify-email\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.0";import * as Sentry from "@sentry/nextjs";
Sentry.init({
	dsn: "https://07e26ed4939511be21e68b3d2498111b@o4508370783764480.ingest.de.sentry.io/4509918029807696",
	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
	sendDefaultPii: true,
	//  performance
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	// We recommend adjusting this value in production
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
	tracesSampleRate: 1.0,
	//  performance
	integrations: [
		//  session-replay
		// Replay may only be enabled for the client-side
		Sentry.replayIntegration(),
		//  session-replay
		//  user-feedback
		Sentry.feedbackIntegration({
			// Additional SDK configuration goes in here, for example:
			colorScheme: "system",
		}),
		//  user-feedback
	],
	//  session-replay
	// Capture Replay for 10% of all sessions,
	// plus for 100% of sessions with an error
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	//  session-replay
	//  logs
	// Enable logs to be sent to Sentry
	enableLogs: true,
	//  logs
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
});
// This export will instrument router navigations, and is only relevant if you enable tracing.
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
